define([
    'ko',
    'jquery',
    'uiComponent',
    'Magento_Customer/js/customer-data'
], function (ko, $, Component, customerData) {
    'use strict';

    //Add a new binding handler to KnockoutJS
    ko.bindingHandlers.afterTextRender = {
        update: function(el, va, ab){
            ab().text && va()(ab().text);
        }
    };

    return Component.extend({
        initialize: function () {
            this._super();

            this.wishlist = customerData.get('wishlist');
        },

        /**
         * If the count on the badge is greater than 0, then show the badge
         *
         * @param {string} value The count value
         */
        showBadgeCount: function(value) {
            var wishlistCounters = $(".wishlist").find('.counter');

            //Need to loop because there is a counter for both the desktop and mobile version of the wishlist icon
            for (var i = 0 ; i < wishlistCounters.length ; i++) {
                var wishlistCounter = $(wishlistCounters[i]);
                wishlistCounter.toggleClass('u-visually-hidden', parseInt(value) == 0);
            }
        }
    });
});
